export {default as Ranges} from './range/Ranges';
export {default as getACS} from './acs/acs.js';



// WEBPACK FOOTER //
// ./node_modules/spectra-data-ranges/src/index.js